import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

const Container = styled(Box)`
	background: ${(props) => props.theme.colors.yellow};
	color: white;
`;

export default function LearningEventWarning() {
	const { t } = useTranslation();

	return (
		<Box mt={5}>
			<Container p={3}>{t('learning.event.modal.edit.notificationWarning')}</Container>
		</Box>
	);
}
